export const STORAGE_AUTH_KEY = "auth"
export const STORAGE_CURRENT_CHAT_KEY = "current_chat"
export const STORAGE_PREVIEW_CHAT_KEY = "preivew_chat"
export const STORAGE_MENU_KEY = "active_menu"